import type { RootState } from "src/store";

export const selectSearch = (state: RootState) => {
  return state.search;
};
